import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const RetrieveInvitationsResponseSchema = z.object({
  brokers: z.array(z.object({ name: z.string(), _id: z.string() })),
});

export type RetrieveInvitationsResponse = z.infer<typeof RetrieveInvitationsResponseSchema>;

export const customsTradeContract = c.router({
  sendBatchToBroker: {
    method: 'POST',
    path: '/customs-trade/:batchId/send-to-broker',
    body: c.noBody(),
    pathParams: z.object({ batchId: z.string() }),
    responses: {
      200: z.object({}),
    },
  },
  syncBatch: {
    method: 'POST',
    path: '/customs-trade/:batchId/sync-batch',
    body: c.noBody(),
    pathParams: z.object({ batchId: z.string() }),
    responses: {
      200: z.object({}),
    },
  },
  retrieveBatchReport: {
    method: 'POST',
    path: '/customs-trade/batch-report',
    body: z.object({
      batchId: z.string(),
    }),
    responses: { 200: z.object({ message: z.string() }) },
  },
  retrieveInvitations: {
    method: 'POST',
    path: '/customs-trade/invitations',
    body: z.object({
      tokens: z.array(z.string()),
    }),
    responses: {
      200: RetrieveInvitationsResponseSchema,
    },
  },
  downloadBatchReport: {
    method: 'POST',
    path: '/customs-trade/download-batch-report',
    body: z.object({
      batchId: z.string(),
      reportId: z.string().optional(),
    }),
    responses: {
      200: z.any(),
      204: z.object({ message: z.string() }),
    },
  },
});
